<jqxTreeGrid (onRowClick)="rowClick($event)"
             [source]="dataAdapter"
             [pageable]="true"
             [sortable]="true"
             [columns]="columns"
             [ready]="ready"
             [pageSize]="40"
             [altRows]="true" 
             [autoRowHeight]="true"
             [rendered]="rendered"
             #TreeGrid>
</jqxTreeGrid>
